import {Language} from "./customEnum";

const English = {
	Loading: 'Loading...',
	AutoLogoutTitle: 'Session Expired',
	AutoLogoutDesc: 'Please reload the page or re-enter with a new link.',
	SendInviteFailedTitle: 'Invitation sending failed',
	SendInviteFailedDesc: 'The patient does not have an iClinicHealth account or mobile phone, please complete it and try again.',
	OK: 'OK',
	Login: 'Login',
	Cancel: 'Cancel',
	Join: 'Join',
	RequestFailed: 'Request failed',
	GetMeetingInfoError: 'Get meeting information error.',
	LoginSuccess: 'Login Successfully',
	Call: 'Call ' ,
	Invite: 'Invite ',
	JoinVideoChat: 'Joining into video chat',
	LogInFailed: 'Login failed',
	LogInFailedDesc: 'Please check the network and reload page.',
	LoginElseWhereTitle: 'Your account has been logged in elsewhere',
	LoginElseWhereDesc: 'Please re-open it from iClinic if you want to log in again.',
	Close: 'Close',
	Reload: 'Reload',
	Alert: 'Alert',
	ForceJoin: 'You are already logged in to this chat room elsewhere, and if you insist on joining, you will be kicked out from other logins. Are you sure you want to join?',
	RegisterComment1: 'Register iClinicHealth account now with code  ',
	RegisterComment2: ' to explore more features. Such as schedule, lab report, vaccination, medication...',
	Register: 'Register',
	RegisterComment: 'Register iClinicHealth account now to explore more features. Such as schedule, lab report, vaccination, medication...',
	TeleHealthConsent: 'Telehealth Consent',
	Accept: 'Accept',
	TelehealthAgreement1: '1. I understand that the laws that protect privacy and the confidentiality of medical information also apply to telemedicine, and that no information obtained in the use of telemedicine which identifies me will be disclosed to researchers or other entities without my consent.  ',
	TelehealthAgreement2: '2. I understand that I have the right to withhold or withdraw my consent to the use of telemedicine in the course of my care at any time, without affecting my right to future care or treatment. ',
	TelehealthAgreement3: '3. I understand that a variety of alternative methods of medical care may be available to me, and that I may choose one or more of these at any time. ',
	TelehealthAgreement4: '4. I understand that it is my duty to inform my medical provider of electronic interactions regarding my care that I may have with other healthcare providers.  ',
	TelehealthAgreement5: '5. I understand the limitation of telemedicine and that I may expect the anticipated benefits from the use of telemedicine in my care, but that no results can be guaranteed or assured.',
	WaitForDoctorOnline: 'The doctor is not online, please wait for the doctor to go online.',
	Calling: 'Calling ',
	ReceiveCalling: 'Receive calling',
	TheVideoIsMuteByPeer: 'The video is disabled by peer',
	VoiceChat: 'Voice chat',
	OpenUrlInBrowserTips: 'Attention: Please use a browser to open this telehealth visit link.',
	BrowserNotSupport: 'Browser does not support.',
	CheckDeviceAndPermission: 'Media device not found. Please check that your microphone and camera are working properly and that you have permissions to the device.',
	ConnectionDisconnectedAndTryAgain: 'The connection was lost due to network fluctuations, please check the network and try again.',
}

const Chinese = {
	Loading: '正在加载',
	AutoLogoutTitle: '会话已过期',
	AutoLogoutDesc: '请重新加载页面或重新输入新链接。',
	SendInviteFailedTitle: '邀请发送失败',
	SendInviteFailedDesc: '患者没有iClinicHealth账号和手机，请完成后再试。',
	OK: '确定',
	Login: '登录',
	Cancel: '取消',
	Join: '加入',
	RequestFailed: '请求失败',
	GetMeetingInfoError: '获取预约信息失败',
	LoginSuccess: '登录成功',
	Call: '呼叫 ',
	Invite: '邀请 ',
	JoinVideoChat: '正在加入视频聊天',
	LogInFailed: '登录失败',
	LogInFailedDesc: '请检查网络并重新加载页面。',
	LoginElseWhereTitle: '您的账户已在其他地方登录',
	LoginElseWhereDesc: '如果你想再次登录，请从iClinic重新打开。',
	Close: '关闭',
	Reload: '重载',
	Alert: '提示',
	ForceJoin: '你已经在其他地方登录了这个聊天室，如果你坚持要加入，就会被其他登录的人踢出。你确定要加入吗？',
	RegisterComment1: '立即使用注册码',
	RegisterComment2: '注册iClinicHealth帐户以探索更多功能: 如预约医生、查看化验报告、疫苗注射、申请开药...',
	Register: '注册',
	RegisterComment: '立即注册iClinicHealth帐户以探索更多功能: 如预约医生、查看化验报告、疫苗注射、申请开药...',
	TeleHealthConsent: '远程医疗同意书',
	Accept: '同意',
	TelehealthAgreement1: '1. 我理解保护隐私和个人医疗保密信息的法律同样适用于远程医疗，并且如果没有我的同意，通过远程医疗获得的关于我个人的信息将不会被披露。',
	TelehealthAgreement2: '2. 我理解我有权利在任何时候撤回我对远程医疗的同意书。',
	TelehealthAgreement3: '3. 我理解除了远程医疗以外，我可能有其他医疗服务的选择; 我可以在任何时候选择这些服务中的一项或多项。',
	TelehealthAgreement4: '4. 我理解我有责任告知我的医生其他医护人员曾经给我提供的电子医疗服务。',
	TelehealthAgreement5: '5. 我理解远程医疗服务的局限性；也理解远程医疗服务的效果或结果不能有保证。',
	WaitForDoctorOnline: '医生不在线上，请等待医生上线。',
	Calling: '正在呼叫 ',
	ReceiveCalling: '收到呼叫 ',
	TheVideoIsMuteByPeer: '视频已被对方禁用',
	VoiceChat: '语音通话',
	OpenUrlInBrowserTips: '注意：请使用浏览器打开此远程医疗访问链接。',
	BrowserNotSupport: '浏览器不支持。',
	CheckDeviceAndPermission: '未找到媒体设备。请检查您的麦克风和摄像头是否正常工作以及您是否拥有该设备的权限。',
	ConnectionDisconnectedAndTryAgain: '由于网络波动导致连接断开，请检查网络后重试。',
}

const Spanish = {
	Loading: 'Cargando...',
	AutoLogoutTitle: 'La sesión expiró',
	AutoLogoutDesc: 'Por favor, recargue la página o vuelva a entrar con un nuevo enlace.',
	SendInviteFailedTitle: 'El envío de la invitación falló',
	SendInviteFailedDesc: 'El paciente no tiene una cuenta de iClinicHealth o un teléfono móvil, por favor complételo e inténtelo de nuevo.',
	OK: 'OK',
	Login: 'Ingresa en',
	Cancel: 'Cancelar',
	Join: 'Únete a',
	RequestFailed: 'La solicitud falló.',
	GetMeetingInfoError: 'Error en la información de la cita',
	LoginSuccess: 'Ingresar con éxito',
	Call: 'Llama a ' ,
	Invite: 'Invitar a ',
	JoinVideoChat: 'Unirse al videochat',
	LogInFailed: 'El inicio de sesión falló',
	LogInFailedDesc: 'Por favor, compruebe la red y recargue la página.',
	LoginElseWhereTitle: 'Su cuenta ha sido registrada en otro lugar',
	LoginElseWhereDesc: 'Por favor, vuelva a abrirlo desde iClinic si quiere volver a entrar.',
	Close: 'Cerrar',
	Reload: 'Recarga',
	Alert: 'Alerta',
	ForceJoin: 'Ya estás conectado a esta sala de chat en otro lugar, y si insistes en unirte, serás expulsado de otros accesos. ¿Estás seguro de que quieres unirte?',
	RegisterComment1: 'Registre la cuenta de iClinicHealth ahora con el código   ',
	RegisterComment2: ' para explorar más características. Como el calendario, el informe del laboratorio, vacunas, medicamento...',
	Register: 'Registración',
	RegisterComment: 'Registre la cuenta de iClinicHealth ahora para explorar más características. Como el calendario, el informe de laboratorio, vacunas, medicamento...',
	TeleHealthConsent: 'Consentimiento de Telesalud',
	Accept: 'Acepta',
	TelehealthAgreement1: '1. Entiendo que las leyes que protegen la privacidad y la confidencialidad de la información médica también se aplican a la telemedicina, y que ninguna información obtenida en el uso de la telemedicina que me identifique será revelada a los investigadores u otras entidades sin mi consentimiento.    ',
	TelehealthAgreement2: '2. Entiendo que tengo el derecho de retener o retirar mi consentimiento para el uso de la telemedicina en el curso de mi atención en cualquier momento, sin que ello afecte a mi derecho a recibir atención o tratamiento en el futuro. ',
	TelehealthAgreement3: '3. Entiendo que puedo disponer de una variedad de métodos alternativos de atención médica y que puedo elegir uno o más de ellos en cualquier momento. ',
	TelehealthAgreement4: '4. Entiendo que es mi deber informar a mi proveedor médico de las interacciones electrónicas con respecto a mi cuidado que pueda tener con otros proveedores de atención médica. ',
	TelehealthAgreement5: '5. Comprendo las limitaciones de la telemedicina y que puedo esperar los beneficios previstos de la utilización de la telemedicina en mi atención, pero que no se pueden garantizar ni asegurar los resultados. ',
	WaitForDoctorOnline: 'El doctor no está en línea, por favor espere a que el doctor se conecte.',
	Calling: 'Llamando a ',
	ReceiveCalling: 'Recibir la llamada de ',
	TheVideoIsMuteByPeer: 'El video está desactivado por el par',
	VoiceChat: 'chat de voz',
	OpenUrlInBrowserTips: 'Atención: utilice un navegador para abrir este enlace de visita de telesalud.',
	BrowserNotSupport: 'La navegador no es compatible.',
	CheckDeviceAndPermission: 'Dispositivo multimedia no encontrado. Verifique que su micrófono y cámara funcionen correctamente y que tenga permisos para el dispositivo.',
	ConnectionDisconnectedAndTryAgain: 'La conexión se perdió debido a las fluctuaciones de la red, verifique la red e intente nuevamente.',
}

const languagePackage = () => {
	let lang = global.userLanguage

	if (lang === Language.chinese) {
		return Chinese
	} else if (lang === Language.spanish) {
		return Spanish
	} else {
		return English
	}
};

export {
	languagePackage
}
